import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import * as moment from "jalali-moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Branch, DetailLedger, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { AccStatusKind, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherDetail } from "../../models/accvoucherdetail.model";
import { AccVoucherHeader } from "../../models/accvoucherheader.model";
import { AccVoucherKind } from "../../models/accvoucherkind.model";
import { SubLedger } from "../../models/subledger.model";
@Component({
  selector: "acc-voucher-header-import-excel-form",
  templateUrl: "./acc-voucher-header-import-excel-form.component.html",
  styleUrls: ["./acc-voucher-header-import-excel-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccVoucherHeaderImportExcelFormComponent extends BaseFormComponent<AccVoucherHeader> {
  isloading: boolean = false;
  gridInfo: GridColumnInfoDetail[];
  SubLedgerList: SubLedger[];
  BranchList: Branch[];
  VoucherState: string;
  DetailLedgerList: DetailLedger[];
  public hColumns: form_control[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "AccVoucherHeader";
    this.label = "دریافت فایل اکسل";
    await super.ngOnInit();
    this.model = <any>{};
    await this.setAccVoucherKind();
    await this.setData();
  }
  async setColumns() {
    await super.setColumns();
    this.hColumns = [];
    this.hColumns.push(<form_control>{
      label: "ردیف اول عنون ستونهاست.",
      controlType: FormControlTypes.checkbox,
      modelName: "isFirstRowColumnsName",
      disabled: false,
      name: "isFirstRowColumnsName",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.hColumns = this.hColumns;
  }
  async setData() {
    if (!this.model.FiscalYearId && this.accountService.authService.currentFiscalYear) {
      this.model.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
      this.model.Year = this.accountService.authService.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        this.model.FiscalYearId = x.Id;
        this.model.Year = x.Year;
      });
    }
    if (!this.model.StatusKindId) {
      this.lookupservice
        .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Inspection)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
        });
    }
    if (!this.model.SystemKindId) {
      this.lookupservice
        .getLookupbyCode("GNR", "SystemKind", SystemKind.ACC)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.SystemKindId = x.Id;
          this.model.SystemKindCode = x.Code;
          this.model.SystemKindTitle = x.Title;
        });
    }
    await this.httpCommonService
      .getList("Branch/GetAllBranch")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.BranchList = data as Branch[];
          }
        },
        (error) => this.getFailedHelper(error)
      );

    await this.httpCommonService
      .getList("SubLedger")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.SubLedgerList = data as SubLedger[];
          }
        },
        (error) => this.getFailedHelper(error)
      );
    await this.httpCommonService
      .getList("DetailLedger")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.DetailLedgerList = data as DetailLedger[];
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  addControl(): void {
    this.setValue("isFirstRowColumnsName", true);
  }
  async onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>evt.target;
    if (target.files.length > 1) {
      alert("انتخاب بیش از یک فایل مجاز نیست.");
      return;
    } else {
      const result = await this.parseExcelDoc(target.files[0]).catch((err) => console.error(err));
      this.SetAccVoucherHeaderInfo(result);
    }
  }
  getDate(newValue: any) {
    var _dateValue = moment.from(newValue, "fa", "YYYY/MM/DD HH:mm:ss").format("YYYY/MM/DD HH:mm:ss") as any;
    return new Date(_dateValue);
  }
  SetAccVoucherHeaderInfo(excelData: any[]) {
    let ColumnsName = [];
    let VoucherNo = 0;
    let VoucherHeader: AccVoucherHeader = <AccVoucherHeader>{};
    VoucherHeader.VoucherNo = 0;
    VoucherHeader.FixNo = 0;
    VoucherHeader.DailyNo = 0;
    VoucherHeader.AccVoucherDetails = [];
    let VoucherDetail: AccVoucherDetail = <AccVoucherDetail>{};
    let ErroeMessage: string = "";
    if (this.formGroup.get("isFirstRowColumnsName")?.value === true) {
      ColumnsName = excelData[0] as any[];
    } else ColumnsName = this.gridInfo.filter((c) => c.name != null && c.title != "عملیات" && !c.hidden) as any[];
    let isFirtsRow: boolean = true;
    let VoucherHeaderList : AccVoucherHeader[] = [];
    for (var i = 0; i < excelData.length; i++) {
      var x = excelData[i];
      let index: number = 0;
      if (this.formGroup.get("isFirstRowColumnsName").value === true && isFirtsRow === true) {
      } else {
        VoucherDetail = <AccVoucherDetail>{};
        ColumnsName.forEach(async (c) => {
          let key: string;
          if (c.name) key = c.name;
          else {
            if (this.gridInfo.some((g) => g.title === c || g.name == c)) {
              key = this.gridInfo.find((g) => g.title === c || g.name == c).name;
            }
          }
          if (key.trim() === "VoucherNo" && VoucherNo !== Number(x[index])) {
            if (!ErroeMessage && VoucherHeader.AccVoucherDetails.length > 0) {
              // this.saveVoucher(VoucherHeader);
              VoucherHeaderList.push(VoucherHeader);
            }
            VoucherHeader = <AccVoucherHeader>{};
            VoucherHeader.AccVoucherDetails = [];
            VoucherHeader.AccVoucherKindId = this.model.AccVoucherKindId;
            VoucherHeader.SystemKindId = this.model.SystemKindId;
            VoucherHeader.StatusKindId = this.model.StatusKindId;
            VoucherHeader.FiscalYearId = this.model.FiscalYearId;
            VoucherHeader.FixNo = 0;
            VoucherHeader.DailyNo = 0;
            VoucherHeader.FiscalMonth = 0;
            VoucherHeader.TotalPrice = 0;
            VoucherHeader.VoucherNo = 0;
            VoucherHeader.FixNo = 0;
            VoucherHeader.DailyNo = 0;
          }
          if (key.trim() === "VoucherNo" || key.trim() === "ShamsiVoucherDate" || key.trim() === "BranchCode" || key.trim() === "HeaderComment") {
           {
            if(key.trim() === "HeaderComment")
             VoucherHeader["Comment"] = x[index];
            else
            VoucherHeader[key.trim()] = x[index];
           } 
            if (key.trim() === "ShamsiVoucherDate") VoucherHeader.VoucherDate = this.getDate(VoucherHeader.ShamsiVoucherDate);
            VoucherNo = VoucherHeader.VoucherNo;
          } else {
            VoucherDetail[key.trim()] = x[index];
            if (key.trim() === "ShamsiTrackDate") VoucherDetail.TrackDate = this.getDate(VoucherDetail.ShamsiTrackDate);
            VoucherDetail.AccVoucherHeaderId = 0;

            if (key.trim() === "BranchCode") {
              VoucherDetail.BranchId = this.BranchList.find((gg) => gg.Code === VoucherHeader.BranchCode)?.Id;
              if (!VoucherDetail.BrandId) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} شعبه ' ${VoucherHeader.BranchCode} پیدا نشد.`), "دریافت سند حسابداری" + ",";
              }
            }
            if (key.trim() === "SubLedgerCode") {
              VoucherDetail.SubLedgerId = this.SubLedgerList.find((gg) => gg.Code === VoucherDetail.SubLedgerCode)?.Id;
              if (!VoucherDetail.SubLedgerId) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} حساب معین ' ${VoucherDetail.SubLedgerCode} پیدا نشد.`),
                  "دریافت سند حسابداری" + ",";
              }
            }
            if (key === "DetailLedgerCode" && VoucherDetail.DetailLedgerCode) {
              VoucherDetail.DetailLedgerId = this.DetailLedgerList.find((gg) => gg.Code === VoucherDetail.DetailLedgerCode)?.Id;
              if (!VoucherDetail.DetailLedgerId) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} حساب تفصیلی 1 ' ${VoucherDetail.DetailLedgerCode} پیدا نشد.`),
                  "دریافت سند حسابداری" + ",";
              }
            }
            if (key === "DetailLedger2Code" && VoucherDetail.DetailLedger2Code) {
              VoucherDetail.DetailLedger2Id = this.DetailLedgerList.find((gg) => gg.Code === VoucherDetail.DetailLedger2Code)?.Id;
              if (!VoucherDetail.DetailLedger2Id) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} حساب تفصیلی 2 ' ${VoucherDetail.DetailLedger2Code} پیدا نشد.`),
                  "دریافت سند حسابداری" + ",";
              }
            }
            if (key === "DetailLedger3Code" && VoucherDetail.DetailLedger3Code) {
              VoucherDetail.DetailLedger3Id = this.DetailLedgerList.find((gg) => gg.Code === VoucherDetail.DetailLedger3Code)?.Id;
              if (!VoucherDetail.DetailLedger2Id) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} حساب تفصیلی 3 ' ${VoucherDetail.DetailLedger3Code} پیدا نشد.`),
                  "دریافت سند حسابداری" + ",";
              }
            }
            if (key === "DetailLedger4Code" && VoucherDetail.DetailLedger4Code) {
              VoucherDetail.DetailLedger4Id = this.DetailLedgerList.find((gg) => gg.Code === VoucherDetail.DetailLedger4Code)?.Id;
              if (!VoucherDetail.DetailLedger4Id) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} حساب تفصیلی 4 ' ${VoucherDetail.DetailLedger4Code} پیدا نشد.`),
                  "دریافت سند حسابداری" + ",";
              }
            }
            if (key === "DetailLedger5Code" && VoucherDetail.DetailLedger5Code) {
              VoucherDetail.DetailLedger5Id = this.DetailLedgerList.find((gg) => gg.Code === VoucherDetail.DetailLedger5Code)?.Id;
              if (!VoucherDetail.DetailLedger5Id) {
                (ErroeMessage += `برای سند ${VoucherHeader.VoucherNo} حساب تفصیلی 5 ' ${VoucherDetail.DetailLedger5Code} پیدا نشد.`),
                  "دریافت سند حسابداری" + ",";
              }
            }
          }
          index++;
        });
        this.VoucherState = `در حال ذخیره سند شماره ${VoucherHeader.VoucherNo} تاریخ ${VoucherHeader.ShamsiVoucherDate}`;
        this.cd.markForCheck();
        if (!VoucherHeader.AccVoucherDetails.some((g) => g.RowNumber === VoucherDetail.RowNumber)) {
          VoucherHeader.AccVoucherDetails.push(VoucherDetail);
        } else {
          console.log(VoucherHeader);
        }
      }
      if (isFirtsRow === true) isFirtsRow = false;
      if (ErroeMessage) break;
    }
    if (!ErroeMessage && VoucherHeader.AccVoucherDetails.length > 0) {
      VoucherHeaderList.push(VoucherHeader);
      // this.saveVoucher(VoucherHeader);

    } else this.sts.showDialog(ErroeMessage, "خطا در دریافت کالا");
    this.saveVoucher(VoucherHeaderList);
  }
  public cancel() {
    this.close();
  }
  saveVoucher(entity) {
    if(!entity || entity?.length <= 0 ) return;
    this.VoucherState = `در حال ذخیره سند شماره`;
    this.cd.markForCheck();
    this.httpCommonService
      .create(this.apiName +"/SaveExcelData", entity)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (row) => {
          this.close();
          this.cd.markForCheck();
        },
        (error) => this.sts.showDialog(`خطای ذخیره تغییرات: ${Utilities.getHttpResponseMessage(error)}`, "پیغام خطا")
      );
  }
  async setAccVoucherKind() {
    await this.httpCommonService
      .get("AccVoucherKind/ReadAccVoucherKindLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data: AccVoucherKind[]) => {
          let vk = data.filter((x) => x.Code === 1 || !x.IsOperating);
          this.selectorService.setDataList("AccVoucherKindId", vk);
          let _vk = vk.find((x) => x.Code === 1);
          if (_vk) {
            this.model.AccVoucherKindId = _vk.Id;
            this.model.AccVoucherKindTitle = _vk.Title;
            this.model.AccVoucherKindCode = _vk.Code;
          }
        },
        (error) => {}
      );
  }
}
